import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import rootReducer from './redux/reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './redux/saga';
import {ConnectedRouter, routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import Routes from './configuration/routes';
import {composeWithDevTools} from 'redux-devtools-extension';
import {loadProgressBar} from 'axios-progress-bar';
import {patchHistory} from './configuration/patches';
import './configuration/i18n';

import './styles/index.less';
import Application from './Application';

const sagaMiddleware = createSagaMiddleware();
export const history = patchHistory(createBrowserHistory());

const middlewares = [sagaMiddleware, routerMiddleware(history)];

loadProgressBar();
export const store = createStore(
  rootReducer(history),
  composeWithDevTools(
    applyMiddleware(...middlewares)
  )
);

sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Application>
        <Routes/>
      </Application>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// /src/index.jsx